import { render, staticRenderFns } from "./CustomersMap.vue?vue&type=template&id=16ef2e23&"
import script from "./CustomersMap.vue?vue&type=script&lang=js&"
export * from "./CustomersMap.vue?vue&type=script&lang=js&"
import style0 from "./CustomersMap.vue?vue&type=style&index=0&id=16ef2e23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports